/* GOWin® Store — sincroniza el badge de ahorro del carrito con las tarjetas de colección */
(() => {
  if (window.GowinCartFeedStyleV2) return;
  window.GowinCartFeedStyleV2 = true;

  let observer;
  let observedDrawer;

  const normalizeSavingsBadges = (root = document) => {
    root.querySelectorAll('.gowin-cart-price__badge').forEach((badge) => {
      const match = (badge.textContent || '').match(/(\d+)\s*%/);
      if (!match) return;

      const percent = match[1];
      const desiredText = `AHORRO ${percent}%`;
      if (badge.textContent !== desiredText) badge.textContent = desiredText;
      badge.setAttribute('aria-label', `Ahorro ${percent} por ciento`);
    });
  };

  const bind = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    normalizeSavingsBadges(drawer);

    if (drawer === observedDrawer) return;
    observer?.disconnect();
    observer = new MutationObserver(() => normalizeSavingsBadges(drawer));
    observer.observe(drawer, { childList: true, subtree: true, characterData: true });
    observedDrawer = drawer;
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bind, { once: true })
    : bind();

  document.addEventListener('cart:updated', bind);
  document.addEventListener('shopify:section:load', bind);
  window.addEventListener('pageshow', bind);
})();
